<template>
  <section
    :class="['lm-col', `lm-col_${ spanClass }`]"
    :style="{
      'padding-right': gutter,
      'padding-left': gutter
    }"
  >
    <slot></slot>
  </section>
</template>

<style scoped lang="scss">
.lm-col {
  float: left;
  box-sizing: border-box;
  &_24 { width: 100% }
  &_23 { width: 95.83% }
  &_22 { width: 91.66% }
  &_21 { width: 87.5% }
  &_20 { width: 83.33% }
  &_19 { width: 79.16% }
  &_18 { width: 75% }
  &_17 { width: 70.83% }
  &_16 { width: 66.66% }
  &_15 { width: 62.5% }
  &_14 { width: 58.33% }
  &_13 { width: 54.16% }
  &_12 { width: 50% }
  &_11 { width: 45.83% }
  &_10 { width: 41.66% }
  &_9 { width: 37.5% }
  &_8 { width: 33.33% }
  &_7 { width: 29.16% }
  &_6 { width: 25% }
  &_5 { width: 20.83% }
  &_4 { width: 16.66% }
  &_3 { width: 12.5% }
  &_2 { width: 8.33% }
  &_1 { width: 4.16% }
}
</style>

<script>
// xs sm md lg
export default {
  props: {
    xsSpan: {
      type: Number,
      require: true
    },
    smSpan: {
      type: Number,
      require: true
    },
    mdSpan: {
      type: Number,
      require: true
    },
    lgSpan: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      gutter: 0
    }
  },
  computed: {
    spanClass() {
      return this.mdSpan
    }
  },
  created() {
    this.gutter = `${ this.$parent._props['mdGutter'] / 2 }px`
  },
}
</script>
